<div class="main">
  <div class="left_panel">
    <div class="logo">
      <app-logo></app-logo>
    </div>

    <div class="menu-button">
      <platform-menu-button></platform-menu-button>
    </div>
  </div>
  <div class="right_panel">
    <div class="breadcrumbs">
      <!-- Empty Space Now -- PBI 10660 -->
    </div>

    <div class="search" [ngClass]="searchExpandClass">
      <!-- <platform-search></platform-search> -->
    </div>

    <div class="notifications">
      <!-- <platform-notifications></platform-notifications> -->
    </div>

    <div class="jobsqueue">
      <!-- <platform-jobsqueue></platform-jobsqueue> -->
    </div>

    <div class="account-menu">
      <platform-account-menu></platform-account-menu>
    </div>
  </div>
</div>
